import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { Articoli } from 'src/app/models/articoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import notify from 'devextreme/ui/notify';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { Dipendente } from 'src/app/models/dipendente';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import _moment from 'moment';
import {
  DxiColumnComponent,
  DxiGroupItemComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoSummaryComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { MovimentoArticoloModel } from 'src/app/models/movimento-articolo';

@Component({
  selector: 'app-grid-consegne',
  templateUrl: './grid-consegne.component.html',
  styleUrls: ['./grid-consegne.component.scss'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxoExportComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoSummaryComponent,
    DxiGroupItemComponent,
  ],
  standalone: true,
})
export class GridConsegneComponent
  extends GestArticoliBaseComponent
  implements OnInit, OnChanges
{
  private articoliS = inject(ArticoliService);
  private ns = inject(NavigatorService);
  private tipiArticoliS = inject(TipiArticoliService);
  private categorieArticoliS = inject(CategorieArticoliService);
  private storService = inject(StorageService);
  private artMatService = inject(ArticoliMatricolaService);
  private dipService = inject(DipendentiService);
  private movService = inject(MovimentoArticoliService);

  @Input() idDipendente: number;
  @Input() exportEnabled = true;

  dataSource: any;
  listArticoli: Articoli[] = [];
  listTipiArticoli: TipiArticoli[] = [];
  listCatArticoli: CategorieArticoli[] = [];
  listArticoliMatricola: ArticoliMatricola[] = [];
  listDipendenti: Dipendente[] = [];

  gestMatricole: boolean;

  popupImageVisible = false;
  currentImage: SafeResourceUrl;

  popupGestioneMatricoleVisible = false;
  selectedArticoloGestMatricola: Articoli;

  constructor() {

    super();

    this.gestMatricole = this.isModVisible('Matricole');
  }

  loadLookups() {
    if (this.gestMatricole) {
      this.artMatService.list().subscribe({
        next: (dati) => {
          this.listArticoliMatricola = dati;
        },
        error: (error) => {
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento articoli matricola', 'warning');
          }
        },
      });
    }

    if (!this.idDipendente) {
      this.dipService.listTemp().subscribe({
        next: (dati) => {
          this.listDipendenti = dati;
        }
      });
    }

    this.articoliS.listTemp().subscribe({
      next: (dati) => {
        this.listArticoli = dati.filter(x => x.attivo == true);
      }
    });

    this.tipiArticoliS.getListTipiArticoliTemp().subscribe({
      next: (dati) => {
        this.listTipiArticoli = dati.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });

    this.categorieArticoliS.listTemp().subscribe({
      next: (dati) => {
        this.listCatArticoli = dati.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
      }
    });
  }

  loadConsegne() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.movService.filtered(0, this.idDipendente, 0))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        const model: MovimentoArticoloModel = {
          idDipendente: values.idDipendente,
          data: values.data,
          dettagli: values.dettagli,
          firmato: values.firmato,
          allegato: values.allegato,
          allegatoByte: values.allegatoByte,
          progr: values.progr,
          listDettaglio: [],
          nominativoDipendente: '',
          inviaMail: false,
        };

        return firstValueFrom(this.movService.insert(model))
          .then(() => {
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (key) => {
        return (
          firstValueFrom(this.movService.remove(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              //throw 'Deletion failed'
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.movService.update(key, values)).catch(() => {
          throw 'Update failed';
        });
      },
    });
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  ngOnInit() {
    this.loadLookups();
  }

  ngOnChanges() {
    this.loadConsegne();
  }

  goToDetail(e: any) {
    this.ns.goToArticoliDetail(e.id);
  }

  //esportazione in excel
  onExporting(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('ArticoliAssegnati');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(function () {
      // https://github.com/exceljs/exceljs#writing-xlsx
      workbook.xlsx.writeBuffer().then(function (buffer: any) {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          worksheet.name + '.xlsx',
        );
      });
    });
    e.cancel = true;
  }

  exportDataPDF() {
    this.movService.stampaListaByDip(this.idDipendente).subscribe((scarica) => {
      saveAs.saveAs(scarica, 'Elenco_assegnati_temp.pdf');
    });
  }

  customizeUltimaConsegna(e: any) {
    return 'Ultima: ' + _moment(e.value).format('DD/MM/yyyy');
  }
}
